import React from 'react';
import moment from 'moment';
import { Modal, FormItem } from 'carbon-components-react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getDmService, getByDmService } from '../../../services/Api';
import CardMessages from './card-communication';
// import appConfig from '../../../config/app-config';
import { Breadcrumb, DatePicker } from '../../../components';
import { forceDownloadAsync } from '../../../lib/validations';

// const {IMAGE_PATH} = appConfig;

class Dashboard extends React.PureComponent {
  state = {
    openExport:false,
    data: {
      mensagensPendentes: {
        total: 0,
        totalPersonalizado: 0,
        totalAte7Dias: 0,
        totalPersonalizadoAte7Dias: 0,
        totalAte3Dias: 0,
        totalPersonalizadoAte3Dias: 0
      },
      mensagensAprovadas: {
        total: 0,
        totalPersonalizado: 0,
        totalAte7Dias: 0,
        totalPersonalizadoAte7Dias: 0,
        totalAte3Dias: 0,
        totalPersonalizadoAte3Dias: 0
      },
      mensagensDevolvidas: {
        total: 0,
        totalPersonalizado: 0,
        totalAte7Dias: 0,
        totalPersonalizadoAte7Dias: 0,
        totalAte3Dias: 0,
        totalPersonalizadoAte3Dias: 0
      }
    }
  };

  componentDidMount() {
    getDmService('/Dashboard/Comunicacao').then(data => {
      this.setState({ data });
    });
  }
  
  openExelModal = () => {
    this.setState(prevState => ({
      openExport: !prevState.openExport,
    }));
  }

  exportExcel = async() => {
    const {DataInicial, DataFinal} = this.state;
    try {
      const data = await getByDmService('/Dashboard/ExportarComunicacao', `?DataInicial=${DataInicial ? moment(DataInicial).format("YYYY/MM/DD") : ""}&DataFinal=${DataFinal ? DataFinal.format("YYYY/MM/DD") : ""}`);
      forceDownloadAsync(data);
    } catch (error) {
      toast.error('Ocorreu uma falha ao gerar o arquivo');
    }
  }

  onDateChange = (date, name) => {    
    const data = date == null ? "" : moment(date)
    this.setState({[name]: data });
  };

  render() {
    const { data, openExport, DataInicial, DataFinal } = this.state;

    return (
      <div>
        <Breadcrumb 
          title="Dashboard Comunicação" 
          description="" 
          renderRight={(
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={() => this.openExelModal()}
              >
                Exportar Excel
              </button>
            </div>
          )}
        />
        <section id="content">
          <div className="bx--grid">
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardMessages
                  title="Pendentes"
                  total={data.mensagensPendentes.total}
                  totalCustom={data.mensagensPendentes.totalPersonalizado}
                  totalPrazoPerdidoDays={data.mensagensPendentes.totalPrazoPerdido}
                  totalPrazoPerdidoDaysCustom={data.mensagensPendentes.totalPrazoPerdidoCustom}
                  total7Days={data.mensagensPendentes.totalAte7Dias}
                  total7DaysCustom={
                    data.mensagensPendentes.totalPersonalizadoAte7Dias
                  }
                  total3Days={data.mensagensPendentes.totalAte3Dias}
                  total3DaysCustom={
                    data.mensagensPendentes.totalPersonalizadoAte3Dias
                  }
                />
              </div>
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardMessages
                  title="Aprovadas"
                  total={data.mensagensAprovadas.total}
                  totalCustom={data.mensagensAprovadas.totalPersonalizado}
                  totalPrazoPerdidoDays={data.mensagensAprovadas.totalPrazoPerdido}
                  totalPrazoPerdidoDaysCustom={data.mensagensAprovadas.totalPrazoPerdidoCustom}
                  total7Days={data.mensagensAprovadas.totalAte7Dias}
                  total7DaysCustom={
                    data.mensagensAprovadas.totalPersonalizadoAte7Dias
                  }
                  total3Days={data.mensagensAprovadas.totalAte3Dias}
                  total3DaysCustom={
                    data.mensagensAprovadas.totalPersonalizadoAte3Dias
                  }
                />
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-12  bx--col-md-6">
                <CardMessages
                  title="Devolvidas"
                  total={data.mensagensDevolvidas.total}
                  totalCustom={data.mensagensDevolvidas.totalPersonalizado}
                  totalPrazoPerdidoDays={data.mensagensDevolvidas.totalPrazoPerdido}
                  totalPrazoPerdidoDaysCustom={data.mensagensDevolvidas.totalPrazoPerdidoCustom}
                  total7Days={data.mensagensDevolvidas.totalAte7Dias}
                  total7DaysCustom={
                    data.mensagensDevolvidas.totalPersonalizadoAte7Dias
                  }
                  total3Days={data.mensagensDevolvidas.totalAte3Dias}
                  total3DaysCustom={
                    data.mensagensDevolvidas.totalPersonalizadoAte3Dias
                  }
                />
              </div>
            </div>
          </div>
        </section>
        {openExport && (
          <Modal
            className="modal-dashboard-agencia"
            modalHeading="Exportar planilha"
            primaryButtonText="Exportar"
            secondaryButtonText="Cancelar"
            onRequestSubmit={() => this.exportExcel()}
            onRequestClose={() => this.openExelModal()}
            open={openExport}
          >
            <div>
              <p>Você pode exportar os dados de todo período ou filtar pela 'Data de solicitação' preenchendo os campos abaixo.</p>
              <div className="bx--row">
                <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                  <FormItem className="v-sm-margin">
                    <label className="bx--label">De</label>
                    <DatePicker
                      id="DataInicial"
                      placeholder="Data Inicial"
                      showClearDate
                      date={DataInicial}
                      locale="pt"
                      readOnly
                      onDateChange={(date) => this.onDateChange(date, 'DataInicial')}
                      isOutsideRange={() => false}
                    />
                  </FormItem>
                </div>
                <div className="bx--col-md-6 bx--col-xs-6 bx--col-sm-6 calendar-dash-agency">
                  <FormItem className="v-sm-margin">
                    <label className="bx--label">Até</label>
                    <DatePicker
                      id="DataFinal"
                      placeholder="Data Final"
                      date={DataFinal && DataFinal !== "Invalid date" ? moment(DataFinal) : ""}
                      locale="pt"
                      readOnly
                      showClearDate
                      onDateChange={(date) => this.onDateChange(date, 'DataFinal')}
                      isOutsideRange={() => false}
                    />
                  </FormItem>
                </div>
              </div>         
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default connect()(Dashboard);



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/communication.js